import * as React from 'react';
import {Option} from "ts-option";
import {EditableProps} from "../../common/props/EditableProps";
import {DisableableProps} from "../../common/props/DisableableProps";
import {FocusableProps} from "../../common/props/FocusableProps";
import {PressableProps} from "../../common/props/PresableProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import CurrencyInput from "../../../hiberUiKit/src/atoms/Input/CurrencyInput";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

type Props =
	DisableableProps
	& EditableProps
	& FocusableProps
	& PressableProps
	& FormGroupProps<string>
	& PlaceholderProps

export default class CurrencyInputFormGroup extends React.Component<Props, {}> {

	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<div className={"input-group"}>
					<CurrencyInput onChange={this.onChange}
								   value={this.props.field.value}
								   placeholder={this.props.placeholder}
								   disabled={this.props.disabled}
								   focus={this.props.focus}
								   onFocus={this.props.onFocus}
								   onEnter={this.props.onEnter}
								   readonly={this.props.readonly}/>
				</div>
			</FormGroup>
		);
	}

	/**
	 * On change action.
	 * @param {Option<string>} value Value of the currency input.
	 */
	onChange(value: Option<string>) {
		this.props.onChange(this.props.field.updateValue(value))
	}
}